import { render } from "./CheckListV2.vue?vue&type=template&id=979dba86&scoped=true&lang=pug"
import script from "./CheckListV2.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckListV2.vue?vue&type=script&setup=true&lang=js"

import "./CheckListV2.vue?vue&type=style&index=0&id=979dba86&lang=sass&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979dba86"]])

export default __exports__